// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2x29F","insightsList":"newBusinessInsightsMenu_insightsList__LcWf0","active":"newBusinessInsightsMenu_active__3CFJg"};